(function() {
  const LOG_PREFIX = '[LGX Header Cart Count Adjuster]';

  function logDebug(...args) {
    // console.log(LOG_PREFIX, ...args); // Uncommented for debugging
  }

  function logError(...args) {
    console.error(LOG_PREFIX, ...args);
  }

  let currentAdjustedCount = -1; // Store the last known correct count
  let observer = null; // To hold the MutationObserver instance
  let isSelfUpdate = false; // Flag to prevent observer reacting to its own changes

  async function lgxAdjustHeaderCartCount() {
    logDebug('Attempting to adjust header cart count.');
    isSelfUpdate = true; // Signal that upcoming changes are from this function

    if (!window.lgxThemeSettings || typeof window.lgxThemeSettings.headerUpsellSourceProductId !== 'number') {
      logError('Upsell source product ID not found in window.lgxThemeSettings.headerUpsellSourceProductId. Ensure the Liquid snippet is correctly placed in theme.liquid and the theme setting is configured.');
      isSelfUpdate = false;
      return;
    }

    const upsellSourceProductId = window.lgxThemeSettings.headerUpsellSourceProductId;
    const effectiveComparisonProductId = upsellSourceProductId;
    logDebug(`Using effective comparison Product ID for upsell: ${effectiveComparisonProductId} (Source ID: ${upsellSourceProductId})`);

    try {
      const response = await fetch(`${Shopify.routes.root}cart.js`);
      if (!response.ok) {
        logError(`Failed to fetch cart.js, status: ${response.status}`);
        isSelfUpdate = false;
        return;
      }
      const cart = await response.json();

      if (!cart || !cart.items) {
        logError('Invalid cart data received from cart.js.');
        isSelfUpdate = false;
        return;
      }
      
      logDebug('Cart items received:', JSON.stringify(cart.items.map(item => ({ id: item.id, product_id: item.product_id, variant_id: item.variant_id, title: item.title, quantity: item.quantity }))));

      let adjustedVisibleItemCount = 0;
      for (const item of cart.items) {
        const itemProductId = parseInt(item.product_id, 10); // Explicitly parse as integer
        logDebug(`Processing item: Title: "${item.title}", Product ID: ${item.product_id} (parsed as ${itemProductId}), Qty: ${item.quantity}`);
        
        if (itemProductId !== effectiveComparisonProductId) {
          adjustedVisibleItemCount += item.quantity;
          logDebug(`   -> INCLUDING item. Product ID ${itemProductId} !== ${effectiveComparisonProductId}`);
        } else {
          logDebug(`   -> EXCLUDING item. Product ID ${itemProductId} === ${effectiveComparisonProductId}`);
        }
      }

      logDebug(`Calculated adjusted cart count: ${adjustedVisibleItemCount}. Original cart.item_count: ${cart.item_count}`);
      currentAdjustedCount = adjustedVisibleItemCount; // Update the stored correct count

      const countElements = document.querySelectorAll('hdt-cart-count');
      logDebug(`Found ${countElements.length} element(s) with selector 'hdt-cart-count'.`);

      if (countElements.length > 0) {
        countElements.forEach((el, index) => {
          logDebug(`  Element ${index}: ID: '${el.id}', Classes: '${el.className}', Current Text: '${el.textContent}'`);
          // For debugging, temporarily change the style to visually confirm
          // el.style.outline = '2px solid red'; 
          // el.style.backgroundColor = 'yellow';

          if (el.textContent !== adjustedVisibleItemCount.toString()) {
            logDebug(`    -> Updating element ${index} from '${el.textContent}' to '${adjustedVisibleItemCount}'`);
            el.textContent = adjustedVisibleItemCount;
          } else {
            logDebug(`    -> Element ${index} already shows correct count '${adjustedVisibleItemCount}'. No DOM update needed.`);
          }
        });
      } else {
        logDebug('No hdt-cart-count elements found to update.');
      }
    } catch (error) {
      logError('Error during cart count adjustment:', error);
    }
    // Brief timeout to allow DOM changes to settle before re-enabling observer checks fully
    setTimeout(() => { isSelfUpdate = false; }, 0);
  }

  function setupMutationObserver() {
    const targetNodes = document.querySelectorAll('hdt-cart-count');
    if (targetNodes.length === 0) {
      logDebug('MutationObserver: No hdt-cart-count elements found to observe yet. Will retry on events.');
      return;
    }

    if (observer) {
      observer.disconnect(); // Disconnect previous observer if any
    }

    const config = { characterData: true, childList: true, subtree: true };

    observer = new MutationObserver((mutationsList, obs) => {
      if (isSelfUpdate) {
        // logDebug('MutationObserver: Change was self-inflicted, ignoring.');
        return; 
      }

      let needsReAdjustment = false;
      for (const mutation of mutationsList) {
        // Check if the mutation target is one of our hdt-cart-count elements or a child of one
        let targetElement = mutation.target;
        if (targetElement.nodeType === Node.TEXT_NODE) {
            targetElement = targetElement.parentElement;
        }

        if (targetElement && typeof targetElement.matches === 'function' && targetElement.matches('hdt-cart-count')) {
            if (targetElement.textContent !== currentAdjustedCount.toString()) {
                logDebug(`MutationObserver: Detected external change on ${targetElement.className}. Text: '${targetElement.textContent}', Expected: '${currentAdjustedCount}'. Re-adjusting.`);
                needsReAdjustment = true;
                break; 
            }
        }
      }

      if (needsReAdjustment) {
        lgxAdjustHeaderCartCount(); // This will set isSelfUpdate = true
      }
    });

    targetNodes.forEach(node => {
      observer.observe(node, config);
      logDebug(`MutationObserver: Now observing element: ID '${node.id}', Classes '${node.className}'`);
    });
    logDebug(`MutationObserver: Setup complete. Observing ${targetNodes.length} elements.`);
  }

  // Initial adjustment and observer setup
  function initialSetup() {
    lgxAdjustHeaderCartCount().then(() => {
        setupMutationObserver();
    });
  }

  document.addEventListener('cart:change', function(event) {
    logDebug('cart:change event detected. Re-adjusting header count and re-evaluating observer.');
    setTimeout(() => {
        lgxAdjustHeaderCartCount().then(() => {
            // It's possible elements were added/removed, so re-setup observer
            setupMutationObserver(); 
        });
    }, 250); 
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialSetup);
  } else {
    initialSetup();
  }

  window.addEventListener('pageshow', function(event) {
    if (event.persisted) { 
      logDebug('pageshow event (from bfcache). Re-adjusting header count and observer.');
      setTimeout(() => {
        lgxAdjustHeaderCartCount().then(() => {
            setupMutationObserver();
        });
    }, 100);
    }
  });

  document.addEventListener('shopify:section:load', function(event) {
    if (event.target && typeof event.target.matches === 'function' && 
        (event.target.id.includes('shopify-section-header') || event.target.querySelector('hdt-cart-count'))) {
      logDebug('shopify:section:load event detected for a relevant section. Re-adjusting header count and observer.', event.target.id);
      setTimeout(() => {
        lgxAdjustHeaderCartCount().then(() => {
            setupMutationObserver();
        });
    }, 150); 
    }
  });

  logDebug('Cart count adjuster script initialised with MutationObserver logic.');

})(); 